import apiClient from "../helpers/apiClient";

export const getMembers = async (params:any={}) => {
    const response = await apiClient.get('/partners/list/', { params: params });
    return response.data;
};

export const getPartnerTypes = async () => {
    const response = await apiClient.get('/partners/types/');
    return response.data.results;
};

export const getRoles = async () => {
    const response = await apiClient.get('/roles/');
    return response.data.results;
};

export const getMember = async (id:any) => {
    const response = await apiClient.get('/partners/'+id+'/');
    return response.data;
};

export interface PartnerPayload {
    company_name: string;
    contact_name: string;
    contact_surname?: string;
    contact_email: string;
    partner_type_id?: string | number;
    description?: string;
    address?: string;
    email?: string;
    emailCompany?: string;
    phone_number?: string;
    contact_phone?: string;
    contact_role?: string;
    logo?: any;
    bank_account?: any;
    bank_accounts?: any;
    [key: string]: any;
}

export const createMember = async (data: PartnerPayload | FormData | any) => {
    const response = await apiClient.post('/partners/register/', data); 
    return response.data.results;
};

export const updateMember = async (id: any, data: Partial<PartnerPayload> | FormData | any) => {
    const response = await apiClient.patch(
        '/partners/' + id + '/',
        data
    );
    return response.data;
};